import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AthleteBiographyStore } from '../../../../common-page-components/stores/entities-store/athlete-biography-store';

@Component({
  selector: 'app-athlete-biography-insights',
  templateUrl: './athlete-insights.component.html',
  styleUrls: ['./athlete-insights.component.scss']
})
export class AthleteBiographyInsightsComponent implements OnInit {

  /**
   * The input model for get the data.
   *
   * @type {AthleteBiographyStore}
   * @memberof AthleteInsightsComponent
   */
  @Input() model: AthleteBiographyStore;

  /**
   * Input for generate the item for carousel dynamic directive.
   *
   * @type {boolean}
   * @memberof AthleteBiographyInsightsComponent
   */
  @Input() forCarousel: boolean = false;

  /**
 * Slide configuration.
 * http://kenwheeler.github.io/slick/
 */
  slideConfig = undefined;

  /**
   * The array with nnumber of insights for set the breakpoints in carousel config.
   *
   * @memberof AthleteBiographyInsightsComponent
   */
  numberOfItems = [];
  constructor(protected translation_service:TranslocoService) { }

  /**
   * {@inheritdoc}
   *
   * @memberof AthleteBiographyInsightsComponent
   */
  ngOnInit() {
    // Calculate number of elements for set the config in the carousel.
    this.numberOfItems = [].concat(
    this.getRankingInsightItems(),
    this.model.olympic_champion,
    this.model.olympic_medallist,
    this.model.paralympic_champion,
    this.model.paralympic_medallist,
    this.model.world_archery_champion,
    this.model.world_medallist,
    this.model.world_cup_champion,
    this.model.olympian,
    this.model.paralympic,
    this.model.world_record_holder,
    this.model.paralympic_record_holder,
    this.model.olympic_record_holder,
    this.model.match_wins,
    this.model.competition_best_compound,
    this.model.competition_best_recurve
    ).filter(Boolean);
    this.slideConfig = {
      slidesToShow: Math.min(Math.max(this.numberOfItems.length, 4), this.numberOfItems.length> 4 ? 4 :this.numberOfItems.length),
      slidesToScroll:  Math.min(Math.max(this.numberOfItems.length, 4), this.numberOfItems.length> 4 ? 4 :this.numberOfItems.length),
      initialSlide: 0,
      dots: this.numberOfItems.length > 4,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            dots:  this.numberOfItems.length > 3,
            slidesToShow:  Math.min(Math.max(this.numberOfItems.length, 3),
             this.numberOfItems.length> 3 ? 3 :this.numberOfItems.length),
            slidesToScroll: Math.min(Math.max(this.numberOfItems.length, 3),
             this.numberOfItems.length> 3 ? 3 :this.numberOfItems.length),
          }
        },

        {
          breakpoint: 750,
          settings: {
            dots:  this.numberOfItems.length > 2,
            slidesToShow: Math.min(Math.max(this.numberOfItems.length, 2), this.numberOfItems.length> 2 ? 2 :this.numberOfItems.length),
            slidesToScroll: Math.min(Math.max(this.numberOfItems.length, 2), this.numberOfItems.length> 2 ? 2 :this.numberOfItems.length),
          }
        },
        {
          breakpoint: 500,
          settings: {
            dots:  this.numberOfItems.length > 1,
            slidesToShow: Math.min(Math.max(this.numberOfItems.length, 1), this.numberOfItems.length> 1 ? 1 :this.numberOfItems.length),
            slidesToScroll: Math.min(Math.max(this.numberOfItems.length, 1), this.numberOfItems.length> 1 ? 1 :this.numberOfItems.length),
          }
        }
        ,




    ]
    };
  }

  getRankingInsightItems() {
    return this.model.data && this.model.data[0] && this.model.data[0]['WorldRankings'] ?
      this.model.data[0]['WorldRankings']['Current'].map(value => {
        const catCode = (value.CatCode);
        const categories = (this.model as AthleteBiographyStore).categories;
        const catName = categories.find(cat => cat.Code === catCode);
        Object.assign(value, { 'CatName': catName.Name })
        return value;
      }).sort((f, s) => f.Rnk > s.Rnk ? 1 : -1) : []
  }

  /**
   * Method as helper for get champion of the category name using com sub level id.
   *
   * @param {number} ComSubLevel
   * @returns
   * @memberof AthleteBiographyInsightsComponent
   */
  getChampionCategoryName(ComSubLevel: number) {
    return {
      "4": this.translation_service.translate("World Archery Champion"),
      "5": this.translation_service.translate("World Youth Champion"),
      "6": this.translation_service.translate("World Para Champion"),
      "7": this.translation_service.translate("World Field Champion"),
      "8": this.translation_service.translate("World Indoor Champion"),
      "9": this.translation_service.translate("World 3D Champion"),
      "10": this.translation_service.translate("World Student Champion")
    }[ComSubLevel]
  }

}
